export const COUPON_IMPORT_LIST_PATH = "/coupon-import";
export const COUPON_IMPORT_CREATE_VIEW_PATH = "/coupon-import/create";
